module.exports = __webpack_public_path__ + "static/media/iconCanvas01.9af580fa.svg";